import { render } from "./EmptyLayoutWithHeader.vue?vue&type=template&id=fd883a02&ts=true"
import script from "./EmptyLayoutWithHeader.vue?vue&type=script&lang=ts"
export * from "./EmptyLayoutWithHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__